/* ★ PEMILIH GEMINI — tahap Thinking Low · Medium · High + akaun satu-model (11 Okt 2026)
 *
 * Google menukar pemilih model Gemini ("Gemini 3", diukur hidup 11 Okt 2026):
 *   · pilihan "Extended thinking" (hidup / mati) DIGANTI tiga tahap — Low, Medium, High;
 *   · akaun tanpa langganan hanya ada SATU model ("Auto"); akaun Ultra kekal ada senarai.
 *
 * Satu fail untuk DUA laluan yang menjalankan agent Gemini (Configure di PRO Studio +
 * larian pukal Workspace) — supaya kedua-duanya membaca tahap dan melapor kegagalan
 * dengan cara yang SAMA (corak `agentGambar.js`).
 *
 * Model data pada doc agent (users/{uid}/chatgptTemplates/{id}):
 *   geminiExtended : 'low' | 'medium' | 'high' | ''   ('' = belum dipilih → larian disekat)
 * ⛔ NAMA MEDAN KEKAL `geminiExtended` walaupun maknanya kini "tahap" — ia tersimpan pada
 *    agent pelanggan dan dijejak di 4 tempat (payload Configure · payload Workspace ·
 *    jambatan content.ts · background.ts). Nilai LAMA 'on' / 'off' dibaca sebagai
 *    high / low, jadi agent lama tidak perlu disimpan semula.
 *
 * ⚠️ KEMBAR: `sesaat (extension)/src/chrome/gemini-automation.js` (TAHAP + normTahap).
 *    Ubah senarai tahap atau pemetaan on/off di satu tempat = ubah kedua-duanya.
 */

export const TAHAP_GEMINI = ['low', 'medium', 'high'];

// Label yang dipapar = perkataan Gemini sendiri (terma produk — tidak diterjemah).
const LABEL = { low: 'Low', medium: 'Medium', high: 'High' };

/** Nilai tersimpan → tahap sah. 'on' → 'high', 'off' → 'low' (agent sebelum 11 Okt). Lain = ''. */
export const normTahapGemini = (v) => {
    const s = String(v || '').trim().toLowerCase();
    if (s === 'on') return 'high';
    if (s === 'off') return 'low';
    return TAHAP_GEMINI.includes(s) ? s : '';
};

export const labelTahapGemini = (v) => LABEL[normTahapGemini(v)] || '';

/**
 * Banding tahap pilihan agent dengan apa yang robot laporkan selepas larian.
 * Pulang null bila tiada masalah (atau tiada maklumat untuk dibanding), atau
 * { mahu, guna, nota } — mahu/guna = label ("High"); guna '' bila tahap sebenar tidak diketahui.
 *
 * `data` = hasil larian daripada extension:
 *   geminiTahapKeadaan 'ok' | 'klik' | 'lama' | 'gagal' | ''   (skrip ≥ 2.1.0; 'klik' = diklik,
 *                      menu tertutup sendiri, tetapi tidak dapat dibaca semula → tiada amaran)
 *   geminiTahapUsed    'low' | 'medium' | 'high' | ''
 *   geminiTahapNota    sebab ringkas bila gagal
 *   geminiExtendedUsed 'on' | 'off'                   (bahasa lama — skrip < 2.1.0 / akaun rupa lama)
 */
export function semakTahapGemini(mahuMentah, data) {
    const mahu = normTahapGemini(mahuMentah);
    if (!mahu || !data || typeof data !== 'object') return null;
    const guna = TAHAP_GEMINI.includes(data.geminiTahapUsed) ? data.geminiTahapUsed : '';
    const lapor = (g) => ({
        mahu: LABEL[mahu],
        guna: g ? LABEL[g] : '',
        nota: String(data.geminiTahapNota || '').trim().slice(0, 160),
    });
    if (data.geminiTahapKeadaan === 'ok') return (guna && guna !== mahu) ? lapor(guna) : null;
    if (data.geminiTahapKeadaan === 'gagal') return lapor(guna);
    // 'klik', akaun yang masih rupa lama ('lama'), atau skrip lama yang belum memulangkan keadaan:
    // hanya ada hidup / mati untuk dibanding. Low = mati · Medium / High = hidup.
    const ext = data.geminiExtendedUsed;
    if (ext !== 'on' && ext !== 'off') return null;   // extension lama: tiada maklumat → tiada amaran
    return ext === (mahu === 'low' ? 'off' : 'on') ? null : lapor('');
}

/** Ayat log kad Workspace bagi hasil `semakTahapGemini` (BM, sama gaya `[Sebab] …` lain). */
export function ayatLogTahapGemini(semakan) {
    if (!semakan) return '';
    const ekor = semakan.guna
        ? ` — jawapan dijana pada tahap "${semakan.guna}"`
        : (semakan.nota ? ` (${semakan.nota})` : '');
    return `[Sebab] Tahap Thinking Gemini tidak dapat ditetapkan ke "${semakan.mahu}"${ekor}`;
}

/**
 * Akaun yang hanya ada SATU model: pulang nama model itu bila pilihan agent bukan model itu
 * (supaya Langkah 4 memapar pilihan yang benar-benar wujud). Selain itu pulang ''.
 */
export function modelTunggalGemini(senarai, semasa) {
    const bersih = Array.isArray(senarai) ? senarai.map((m) => String(m || '').trim()).filter(Boolean) : [];
    if (bersih.length !== 1) return '';
    return bersih[0] === String(semasa || '').trim() ? '' : bersih[0];
}
